import React from "react";

import { DEFAULT_NAV_CHROME_BOTTOM, useNavChromeBottom } from "../../hooks/useNavChromeBottom";

/**
 * Full-viewport pane pinned below the nav chrome — the layout every wizard page uses.
 * The pane stays hidden until the chrome has actually been measured so it can't paint
 * at the assumed offset first and then jump.
 */
export const NavChromeFixedContainer = ({ children }: { children?: React.ReactNode }) => {
	const { topOffset, measureRef } = useNavChromeBottom();

	return (
		<div
			ref={measureRef}
			className="fixed inset-x-0 bottom-0 z-10 overflow-hidden"
			style={{
				top: topOffset ?? DEFAULT_NAV_CHROME_BOTTOM,
				visibility: topOffset === null ? "hidden" : "visible",
			}}
		>
			{children}
		</div>
	);
};
